// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navigation_navigation__1VtLy","link":"Navigation_link__12o2K"};